<script lang="ts" setup>
    const props = defineProps<{ blok: ATextComponentStoryblok }>();

    const textClasses = computed(() => {
        const textAlign = props.blok.textAlign !== 'left' ? `--text-align-${props.blok.textAlign}` : '';
        const textAlignDesktop = props.blok.textAlignDesktop
            ? `--text-align-desktop-${props.blok.textAlignDesktop}`
            : '';
        const textSize = props.blok.textSize !== 'default' ? `--text-size-${props.blok.textSize}` : '';
        const forceCenterPosition = props.blok.forceCenterPosition ? '--force-center' : '';
        const disableTextWidthRule = props.blok.disableTextWidthRule ? '--disable-width' : '';
        const disableHyphenation = props.blok.disableHyphenation
            ? `--disable-hyphenation-${props.blok.disableHyphenation}`
            : '';
        const disableLinkColor = props.blok.disableLinkColor ? '--disable-link-color' : '';

        return [
            textAlign,
            textAlignDesktop,
            textSize,
            forceCenterPosition,
            disableTextWidthRule,
            disableHyphenation,
            disableLinkColor
        ].filter(Boolean); // Removes any empty strings
    });

    const htmlRef = useTemplateRef<HTMLDivElement>('htmlRef');
    onMounted(() => {
        if (htmlRef.value && props.blok.linksOpenNewTab) {
            const links = htmlRef.value.querySelectorAll('a');

            links.forEach((link) => {
                if (!link.hasAttribute('uuid')) {
                    link.target = '_blank';
                }
            });
        }
    });
</script>

<template>
    <div
        ref="htmlRef"
        v-editable="props.blok"
        class="text"
        :class="textClasses"
    >
        <RichText :doc="blok.text" />
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/text/text.scss';
</style>
